import React, { useEffect, useState } from 'react';
import '../../styles/ChargeEventBucket.scss';
import moment from 'moment';
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
import SearchBox from 'app/shared/SearchBox';
import { download_csv, JSONSearch } from 'utils/HelperFunctions';
import { getUserInfo } from 'utils/auth';
import BarChart from 'app/shared/BarChart';
import Tabs from 'app/shared/Tabs';
import Tooltip from 'app/shared/Tooltip';
import { VariableSizeList as List } from 'react-window';

const eventColor = ['#6FDEFC', '#16BCE9', '#12ABD4', '#0F8DAF', '#297286'];

let tabs = [
	{
		key: 'range',
		label: 'Range',
	},
	{
		key: 'all',
		label: 'ALL',
	},
];

function ChargeEventBucket(props) {
	const [openModal, setOpenModal] = useState(false);
	// eslint-disable-next-line
	const [modalLoading, setModalLoading] = useState(false);
	const [eventData, setEventData] = useState([]);
	const [filteredReport, setFilteredReport] = useState([]);
	const [bucket, setBucket] = useState(0);
	const [activeModalTab, setActiveModalTab] = useState('all');
	const [activeBar, setActiveBar] = useState('');
	const [copiedVehicle, setCopiedVehicle] = useState('');
	const [isLoading, setisloading] = useState(false);

	useEffect(() => {
		document.onkeydown = function (evt) {
			evt = evt || window.event;
			//eslint-disable-next-line
			if (evt.keyCode == 27) {
				setOpenModal(false);
				props.openModal(false);
				setActiveModalTab('all');
			}
		};
		getExpArry();
		// eslint-disable-next-line
	}, []);
	const findVehicleNo = (id) => {
		let vehicleInfo = props.vehicleList.find((vehicle) => vehicle.vehicleid === parseInt(id));
		return vehicleInfo ? vehicleInfo.vehicleno : id;
	};
	const assignVehicles = (eventList) => {
		let newEventList = [];
		for (let idx in eventList) {
			let count = 0;
			if (window.barItemclicked) {
				let tempEvent = eventList[idx][1];
				for (let rdx in tempEvent) {
					count = count + tempEvent[rdx].length;
				}
			}
			newEventList.push({
				vehicleno: findVehicleNo(eventList[idx][0]),
				events: eventList[idx][1],
				itemCount: count,
			});
		}
		return newEventList;
	};

	const searchEvents = (key) => {
		setModalLoading(true);
		// eslint-disable-next-line
		let searchData = eventData.find((event) => event.bucket == bucket);
		let result = JSONSearch(key, searchData.events, ['vehicleno']);
		setFilteredReport(result);
		setTimeout(() => {
			setModalLoading(false);
		}, 100);
	};
	const getCSVName = () => {
		let auth = getUserInfo();
		let date = moment().format('DD-MM-YYYY_h:mmA');
		return auth.username + '_Charging_Events_Per_Vehicel_Per_Day_' + date + '.csv';
	};

	const JSONToCSV = () => {
		let reportData = filteredReport;
		let str = '';
		let heads = [
			{
				hdg: 'Vehicle No',
			},
			{
				hdg: 'Chraging Started At',
			},
			{
				hdg: 'Start SOC (%)',
			},
			{
				hdg: 'Chraging Ended At',
			},
			{
				hdg: 'End SOC (%)',
			},
		];
		let headline = '';
		for (var i = 0; i < heads.length; i++) {
			if (headline !== '') headline += ',';
			headline += heads[i]['hdg'];
		}
		str += headline + '\r\n';

		for (let idx in reportData) {
			let line = '';
			if (line !== '') line += ',';
			line += reportData[idx].vehicleno;

			str += '\r\n' + line;
			line = '';
			for (let jdx in reportData[idx].events) {
				if (line !== '') line += ',';
				line += ',';
				line +=
					moment(reportData[idx].events[jdx][0].starttime).format('D MMM YYYY h:mm A') +
					',' +
					reportData[idx].events[jdx][0].startsoc +
					',' +
					moment(reportData[idx].events[jdx][0].endtime).format('D MMM YYYY h:mm A') +
					',' +
					reportData[idx].events[jdx][0].endsoc;

				str += line + '\r\n';
				line = '';
			}
			// str+=line+"\r\n";
		}
		download_csv(str, getCSVName());
	};

	const getExpArry = (arr = Object.entries(props.data)) => {
		let finalArray = [];
		let initArray = arr.map((initArry) => initArry[1].count);
		initArray = initArray.filter((val) => val !== 0);
		// eslint-disable-next-line
		let sumOfArray = eval(initArray.join('+'));
		let expArr = [];
		for (let idx in initArray) {
			let div = initArray[idx] / sumOfArray;
			expArr.push(Math.pow(Math.exp(div), 2));
		}
		// eslint-disable-next-line
		let expSum = eval(expArr.join('+'));
		for (let idx in expArr) {
			expArr[idx] = ((expArr[idx] / expSum) * 100).toFixed(1);
		}
		for (let idx in arr) {
			finalArray.push({
				barWidth: expArr[idx],
				events: assignVehicles(Object.entries(arr[idx][1].events)),
				count: arr[idx][1].count,
				bucket: arr[idx][0],
				dist: arr[idx][1].dist,
			});
		}
		setEventData(finalArray);
	};

	const filterListData = (data) => {
		setActiveBar(data);
		setActiveModalTab('range');
		let prevData = eventData.find((event) => event.bucket === bucket);
		let finalData = assignVehicles(
			Object.entries(prevData.dist[data.data.range.replace('%', '')].val)
		);
		setFilteredReport(finalData);
		setTimeout(() => {
			setModalLoading(false);
		}, 500);
	};

	const filterSetAll = (key) => {
		setModalLoading(true);
		window.barItemclicked = false;
		// eslint-disable-next-line
		let searchData = eventData.find((event) => event.bucket == bucket);
		setFilteredReport(searchData.events);
		setTimeout(() => {
			setModalLoading(false);
		}, 100);
	};
	const setFilteredData = (idx) => {
		window.barItemclicked = false;
		setFilteredReport(eventData[idx].events);
		setBucket(eventData[idx].bucket);
		setTimeout(() => {
			setisloading(false);
		}, 1000);
	};
	const getSize = (index) => {
		let entries = Object.keys(filteredReport[index].events).length;

		let count;
		let bucketno = parseInt(bucket);
		let itemCount = filteredReport[index].itemCount;
		switch (bucketno) {
			case 1:
				count = entries === 1 ? 136 : entries * 53 + 83;
				return count;
			case 2:
				count = parseInt(entries, 10);

				if (itemCount) {
					let tempCount = entries * 2 - itemCount;
					count = itemCount === 1 ? 136 : itemCount * 53;
					if (tempCount !== itemCount) {
						count = entries * 85.6 - tempCount * 32;
					}
					if (itemCount > 1) count = count + 83;
					return count;
				}
				count = 83 + count * 85.6;
				return count;
			case 3:
				count = parseInt(entries, 10);
				if (itemCount) {
					let tempCount = entries * 3 - itemCount;
					if (tempCount === 0) count = count * 119;
					if (itemCount === 1) count = 136;
					// count = itemCount === 1 ? 136 : (itemCount*53)
					if (tempCount !== itemCount && itemCount > 1) {
						count = entries * 119 - tempCount * 32;
					}
					if (tempCount === itemCount) {
						count = itemCount * 45.8;
					}
					if (itemCount > 1) count = count + 83;
					return count;
				}
				count = 83 + count * 119;
				return count;
			case 4:
				count = parseInt(entries, 10);
				if (itemCount) {
					let tempCount = entries * 4 - itemCount;
					if (tempCount === 0) count = count * 151.19;
					if (itemCount === 1) count = 136;
					if (tempCount !== itemCount && itemCount > 1) {
						count = entries * 151.19 - tempCount * 32;
					}
					if (tempCount === itemCount) {
						count = itemCount * 45.8;
					}
					if (itemCount > 1) count = count + 83;
					return count;
				}
				count = 83 + count * 151.19;
				return count;
			case 5:
				count = parseInt(entries, 10);
				if (itemCount) {
					let tempCount = entries * 5 - itemCount;
					// count = itemCount === 1 ? 136 : (itemCount*41) + 100
					if (tempCount === 0) count = count * 184;
					if (itemCount === 1) count = 136;
					if (tempCount !== itemCount && itemCount > 1) {
						count = entries * 184 - tempCount * 32;
					}
					if (tempCount === itemCount) {
						count = itemCount * 45.8;
					}
					if (itemCount > 1) count = count + 83;

					return count;
				}
				count = 83 + count * 184;
				return count;
			default:
				return 120;
		}
	};
	const RenderTable = ({ index, key, style }) => {
		return (
			<div className="EventsDay" style={style}>
				<div className="DayBucketing">
					<Tooltip
						text={
							copiedVehicle === 'mysocvehicle' + index ? (
								<>
									Copied <i className="fas fa-check-circle"></i>
								</>
							) : (
								'Click to copy vehicle no'
							)
						}
					>
						<div
							onClick={(e) => copyVehicleNo('mysocvehicle' + index, e)}
							id={'mysocvehicle' + index}
							className="date"
						>
							{filteredReport[index].vehicleno}
						</div>
					</Tooltip>
				</div>
				{Object.entries(filteredReport[index].events).map((dayEvent, key2) => {
					return (
						<div className="EventBox">
							<div className="EventBoxLeft">
								<span
									style={{
										marginLeft: '0.5rem',
										fontSize: 13,
										fontWeight: 500,
									}}
								>
									{moment(parseInt(dayEvent[0])).format('D MMM YY')}
								</span>
							</div>
							<div className="EventBoxRight">
								{dayEvent[1].map((cdevent, key3) => {
									return (
										<div
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
												gap: '10px',
											}}
										>
											<div className="StatsChip">
												<div>Soc Charged</div>
												<div>{`${cdevent.soccharged} %`}</div>
											</div>
											<div className="StatsChip">
												<div>
													{moment(cdevent.starttime).format('h:mm A')} -{' '}
													{moment(cdevent.endtime).format('h:mm A')}
												</div>
												<div>
													{/* {cdevent[0].value} - {cdevent[0].value} */} {cdevent.startsoc + '%'} -{' '}
													{cdevent.endsoc + '%'}
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					);
				})}
			</div>
		);
	};

	const renderChargingEvents = () => {
		// eslint-disable-next-line
		let eventUIs = [];
		for (let idx in eventData) {
			eventUIs.push(
				<div
					key={idx}
					className="Tooltip"
					style={{ width: eventData[idx].barWidth + '%', background: eventColor[idx] }}
				>
					<div
						className="Bucket"
						onClick={() => {
							setisloading(true);
							setFilteredData(idx);
							// setFilteredReport(eventData[idx].events);
							// setBucket(eventData[idx].bucket);
							setOpenModal(true);
						}}
					>
						<div className="Item">
							<i className="fas fa-bolt" style={{ color: '#30dba2', marginRight: 6 }}></i>
							<small className="bucketvalue">{eventData[idx].bucket}</small>
						</div>
						<div className="Item">
							{/* <img src={CountIcon} /> */}
							<small className="bucketvalue">{eventData[idx].count}</small>
							<div className="perc">
								{
									// eslint-disable-next-line
									(
										(eventData[idx].count /
											// eslint-disable-next-line
											eval(eventData.map((event) => event.count).join('+'))) *
										100
									)
										// eslint-disable-next-line
										.toFixed(1)
								}
								{'%'}
							</div>
						</div>
						{/* <span>{eventData[idx].event}</span> */}
					</div>
					<span className="tooltiptext">
						{
							// eslint-disable-next-line
							((eventData[idx].count / eval(eventData.map((event) => event.count).join('+'))) * 100)
								// eslint-disable-next-line
								.toFixed(1)
						}
						% of the time there were {eventData[idx].bucket} charging event(s) per asset per day"
					</span>
				</div>
			);
		}
		return eventUIs;
	};

	const getBarData = () => {
		let barData = [];
		let prevData = eventData.find((event) => event.bucket === bucket);
		if (!prevData) return [];
		let keyMap = Object.entries(prevData.dist || {});
		for (let idx in keyMap) {
			barData.push({
				range: keyMap[idx][0] + '%',
				value: keyMap[idx][1].count,
			});
		}
		return barData;
	};

	const getTabConfig = () => {
		let prevData = JSON.parse(JSON.stringify(tabs));
		if (activeBar && activeModalTab === 'range') {
			prevData[0].label = activeBar.data.range;
			return prevData;
		} else {
			return [prevData[1]];
		}
	};
	const copyVehicleNo = (containerid, e) => {
		e.stopPropagation();
		let r = document.createRange();
		r.selectNode(document.getElementById(containerid));
		window.getSelection().removeAllRanges();
		window.getSelection().addRange(r);
		document.execCommand('copy');
		window.getSelection().removeAllRanges();
		setCopiedVehicle(containerid);
	};

	return (
		<div className="ChargingBuckets">
			{renderChargingEvents()}

			<div className="Modal" style={{ display: openModal ? 'block' : 'none' }}>
				<div className="ModalContent">
					<div className="ModalHeader">
						<div className="HeaderLeft">
							<span>
								{moment(props.timerange.starttime).format('MMM DD')} -{' '}
								{moment(props.timerange.endtime).format('MMM DD')}
							</span>
						</div>

						<div style={{ display: 'flex', alignItems: 'center' }}>
							<div className="SearchControl">
								<SearchBox placeholder={'Search'} rounded onSearch={searchEvents} />
							</div>
							<DownloadIcon onClick={JSONToCSV} style={{ cursor: 'pointer', marginRight: 14 }} />

							<span
								onClick={() => {
									setOpenModal(false);
									setActiveModalTab('all');
								}}
								className="close"
							>
								&times;
							</span>
						</div>
					</div>
					{!isLoading && filteredReport ? (
						<div className="MainModalContainer">
							<div className="ModalHeading">
								<div className="heading">Vehicles with {bucket} charging events per day</div>{' '}
							</div>
							<div className="ModalContainer">
								<div className="WidgetView">
									<div className="GraphView">
										<BarChart
											data={getBarData()}
											color={'#59ca93'}
											onClick={(data) => {
												window.barItemclicked = true;
												setModalLoading(true);
												filterListData(data);
											}}
											axisLegends={{
												bottom: 'SOC Charged/per charging event',
												left: 'No of events',
											}}
											cursor={true}
										/>
									</div>
									<div className="ListView">
										{modalLoading ? (
											<div className="insideModalLoading">
												LOADING<span></span>
											</div>
										) : (
											<div className="EventsView">
												<div
													style={{
														position: 'relative',
														top: '0px',
														marginBottom: '16px',
														width: '100%',
														display: 'flex',
														justifyContent: 'flex-end',
													}}
												>
													<Tabs
														tabs={getTabConfig()}
														onChange={(tab) => {
															if (tab === 'all') {
																filterSetAll();
															}

															setActiveModalTab(tab);
														}}
														activeTab={activeModalTab}
													/>
												</div>
												<List
													className="EventsViewContainer"
													height={600}
													itemCount={filteredReport.length}
													itemSize={getSize}
													width={'100%'}
												>
													{RenderTable}
												</List>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					) : (
						<div className="modalLoading">
							LOADING<span></span>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

export default ChargeEventBucket;
